import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface QueryParams {
  key_word: string
  /** 秒级时间戳，由页面 useParseTime 写入 */
  start_time?: number | string
  /** 秒级时间戳，由页面 useParseTime 写入 */
  end_time?: number | string
  sort: string
  asc: boolean
  page: number
  limit: number
  event_types?: number[] | string
}

export interface LogData {
  record_id: string
  record_time: string
  /** 接口原始事件类型：1-加入团队 2-卸载 3-离开 4-管理员删除 5-拉黑 */
  event_type: number
  device_id: string
  computer_name: string
  user_mark: string
  group_name: string
  client_ip: string
  system_ip: string
  mac: string
}

@Injectable()
export class InOutLogService {
  constructor (private http: Http) {
  }

  @ParamsClean()

  @InvokeThrottle()
  getLogList (params: Partial<QueryParams>) {
    return this.http.post<{
      total: number
      list: LogData[]
    }>('/logmanage/join-record/list', params).then(response => response)
  }
}
